// Static brand color palette per team. Driver→team mapping now lives in the
// DB (session_drivers) and is fetched per-session via useDrivers(); the names
// here just need to match what the worker writes (TEAM_NAME_NORMALIZE in
// worker-python/src/pull_latest_race.py).

const TEAM_ORDER = [
  'Red Bull',
  'McLaren',
  'Ferrari',
  'Mercedes',
  'Aston Martin',
  'Alpine',
  'Williams',
  'Racing Bulls',
  'Audi',
  'Haas',
  'Cadillac',
];

const TEAM_COLORS = {
  'Red Bull': '#3671c6',
  McLaren: '#ff8000',
  Ferrari: '#e8002d',
  Mercedes: '#27f4d2',
  'Aston Martin': '#229971',
  Alpine: '#00a1e8',
  Williams: '#1868db',
  'Racing Bulls': '#6692ff',
  Audi: '#52e252',
  Haas: '#b6babd',
  Cadillac: '#c8b582',
};

// Prefer the curated brand color when available; fall back to whatever
// FastF1 provides per session, then a neutral gray.
export const teamColor = (team, dbHex = null) =>
  TEAM_COLORS[team] || dbHex || '#9ca3af';

export const teamSortIndex = (team) => {
  const i = TEAM_ORDER.indexOf(team);
  return i === -1 ? TEAM_ORDER.length : i;
};
